
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class ProductLabourImportDialog extends Serenity.PropertyDialog<any, any>
    {
        protected getFormKey() { return ProductImportExcelForm.formKey; }
        protected useViewMode() { return true; }
        
        protected form = new ProductImportExcelForm(this.idPrefix);

        public products: Inventory.OpeningStockItemsRow[];
        public issues: any[];
        public labors: any[];
        public createlabour: boolean;
        constructor() {
            super();

            this.form = new ProductImportExcelForm(this.idPrefix);
        }
        onDialogClose() {
            super.onDialogClose();

        }

        protected getDialogTitle(): string {
            return "Excel Import";
        }
        protected getDialogButtons() {
            return [
                {
                    text: 'Import',
                    click: () => {
                        if (!this.validateBeforeSave())
                            return;

                        if (this.form.FileName.value == null ||
                            Q.isEmptyOrNull(this.form.FileName.value.Filename)) {
                            Q.notifyError("Please select a file!");
                            return;
                        }

                        Common.ExcelImportService.ProductLabourExcelImport({
                            FileName: this.form.FileName.value.Filename,
                            CreateLabour: this.createlabour
                        }, response => {
                            this.issues = response.RateIssues;
                            this.labors = response.Labours;
                            this.dialogClose();
                        }, { async: false });
                        if (this.issues.length > 0) {
                            Q.postToService({
                                service: ExcelImportService.baseUrl + '/RateIssuesExportExcel',
                                request: {
                                    RateIssues: this.issues,
                                },

                                target: '_blank'
                            });
                        }
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }
    }
}